<template>
  <div>
    <div class="col-sm-12">
      <label>Notes</label>
          <textarea class="bg-lighter w-100 mt-1" rows="15" v-model="bulkObject.note"></textarea>
    </div>

  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        created: function(){
        },
        props: {
            bulkObject: {
                type: Object
            }
        },
        data: function() {
            return {
            }
        },
        computed: {
            ...mapGetters([]),
        },
        asyncComputed: {

        },
        methods: {
            ...mapActions([]),
        },
        components: {
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// areaNotes.vue?5fcfc4b1